import Vue from 'vue';
import moment from 'moment';

const initFilters = () => {

    Vue.filter('comma', (value) => {
        if(value == null) return '';
        if(value === '.0000') value = 0;
        var parts = value.toString().split(".");
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    });

    Vue.filter('unit10000', (value) => {
        if(value == null) return '';
        if(value === '.0000') value = 0;
        return (value / 10000).toFixed(1) + '만';
    });

    Vue.filter('uncomma', (value) => {
        value = String(value);
        return value.replace(/[^\d]+/g, '');
    });

    Vue.filter('nl2br', (value) => {
        return value.replace(/\r\n/g, "<br>").replace(/\n/g, "<br>");
    });
    Vue.filter('dateLength10', (value) => {
        if(!value) return '';
        return value.substr(0, 10);
    });
    Vue.filter('dateLength16', (value) => {
        if(!value) return '';
        return value.substr(0, 16);
    });
    Vue.filter('dateLength19', (value) => {
        if(!value) return '';
        return value.substr(0, 19);
    });
    Vue.filter('career', (value) => {
        if(!value) return '';
        const year = value.substr(0, 4);
        return '구력 ' + (new Date().getFullYear() - parseInt(year) + 1) + '년';
    });

    Vue.filter('dotToYearMonth', (value) => {
        if(!value) return '';
        const year = value.substr(0, 4);
        const month = parseInt(value.substr(5, 2));


        return year + '년 ' + month + '월';
    });

    Vue.filter('dotDate', (value) => {
        if(!value) return '';
        return value.substr(0, 10).replace(/-/g, '.');
    });

    Vue.filter('slashDateStr', (dateStr) => {
        if(!dateStr) return '';
        return dateStr.substr(5, 11).replace(/-/g, '/');
    });

    Vue.filter('dotDateStr', (dateStr) => {
        if(!dateStr) return '';
        return dateStr.substr(0, 10).replace(/-/g, '.');
    });

    Vue.filter('dotDateStr16', (dateStr) => {
        if(!dateStr) return '';
        return dateStr.substr(0, 16).replace(/-/g, '.');
    });
    Vue.filter('ShortDotDate', (value) => {
        if(value == null || value.length < 8) return value;
        var replacedStr = value.replace(/-/g, '.');
        return replacedStr.substr(2, 8);
    });

    Vue.filter('agoDateStr', (dateStr) => {
        if(!dateStr) return '';
        const nowInstance = moment();
        const nowUnix = nowInstance.unix();
        const startInstance = moment(dateStr, 'YYYY-MM-DD HH:mm:ss');
        const startUnix = startInstance.unix();

        let diff = nowUnix - startUnix;
        let str = '';
        if(diff < 60){
            if(diff < 0) diff = 0;
            str = diff + '초 전';
        }else if(diff < 3600){
            str = Math.floor(diff / 60) + '분 전';
        }else if(diff < 86400){
            str = Math.floor(diff / 3600) + '시간 전';
        }else if(diff < 2592000){
            str = Math.floor(diff / 86400) + '일 전';
        }else if(diff < 31536000){
            const duration = moment.duration(nowInstance.diff(startInstance));
            str = Math.floor(duration.asMonths()) + '개월 전';
        }else {
            const duration = moment.duration(nowInstance.diff(startInstance));
            str = Math.floor(duration.asYears()) + '년 전';
        }

        return str;
    });

    Vue.filter('chatTimeStr', (dateStr) => {
        if(!dateStr) return '';
        let hour = dateStr.substr(11, 2);
        if(parseInt(hour) > 12){
            hour = (hour - 12);
            if(parseInt(hour) < 10) hour = '0' + hour;
            hour = '오후 ' + hour;
        } else {
            hour = '오전 ' + hour;
        }
        let min =  dateStr.substr(14, 2);
        return hour + ':' + min;
    });

}

export default initFilters;